import { MfValidationsValidator } from '@/bpc/utils/MfValidationsValidator';
import { getValueByPath } from '@/bpc/mf-fields/types/utils';
export class OnboardingField {
    constructor(absolutePath, field, payload, enumLimits) {
        this.payload = payload;
        this.mfField = field;
        this.trackFieldValueWithAnalytics = field.trackFieldValueWithAnalytics;
        this.absolutePath = absolutePath;
        this.type = field.type;
        this.label = field.label;
        this.tooltipText = field.tooltip;
        this.fallbackTooltip = field.fallbackTooltip;
        this.fallbackLabel = field.fallbackLabel;
        this.applicableDependsOn = field.applicableDependsOn || [];
        if (field.mfValidation != null) {
            this.validator = new MfValidationsValidator(field.mfValidation, () => this.payload, this.absolutePath);
        }
        this.enumLimits = enumLimits;
    }
    applicable() {
        if (this.applicableCache === undefined) {
            this.applicableCache = this.mfField.applicable(this.payload, this.absolutePath);
        }
        return this.applicableCache;
    }
    customConfiguration() {
        var _a, _b;
        if (this.customConfigurationCache === undefined) {
            this.customConfigurationCache = (_b = (_a = this.mfField).customConfiguration) === null || _b === void 0 ? void 0 : _b.call(_a, this.payload);
        }
        return this.customConfigurationCache;
    }
    mandatory() {
        if (this.mandatoryCache === undefined) {
            this.mandatoryCache = this.mfField.mandatory(this.payload, this.absolutePath);
        }
        return this.mandatoryCache;
    }
    disabled() {
        if (this.disabledCache === undefined) {
            this.disabledCache = this.mfField.disabled(this.payload, this.absolutePath);
        }
        return this.disabledCache;
    }
    clearCaches() {
        this.applicableCache = undefined;
        this.customConfigurationCache = undefined;
        this.mandatoryCache = undefined;
        this.filledCache = undefined;
        this.disabledCache = undefined;
    }
    enumOptions() {
        return this.mfField.options;
    }
    filled() {
        if (this.filledCache === undefined) {
            const value = getValueByPath(this.payload, this.absolutePath);
            this.filledCache = value !== null && value !== undefined && value !== '';
        }
        return this.filledCache;
    }
    labelForEnumValue(value) {
        var _a, _b;
        return (_b = (_a = this.mfField.options) === null || _a === void 0 ? void 0 : _a.find(option => option.key === value)) === null || _b === void 0 ? void 0 : _b.label;
    }
    fallbackLabelForEnumValue(value) {
        var _a, _b;
        return (_b = (_a = this.mfField.options) === null || _a === void 0 ? void 0 : _a.find(option => option.key === value)) === null || _b === void 0 ? void 0 : _b.fallbackLabel;
    }
}
